var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyCnh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136708)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136708)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.441406,
    y: 3.2832,
    width: 55,
    height: 36.5837,
    rx: 6.87414,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.441406 3.2832H55.4414V39.8669H0.441406V3.2832Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48804 17.8755L8.95643 7.47021L12.4248 17.8755L3.17578 11.5167H14.7371L5.48804 17.8755Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5282 7.66939L16.9588 8.46039L19.3397 5.68592L19.1062 9.41999L17.1254 6.11421L20.5282 7.66939Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1375 12.2345L20.5407 11.5792L23.8113 9.9453L22.1478 13.2965L21.6042 9.48126L24.1375 12.2345Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6052 18.6404L20.5884 16.5751L24.241 16.4172L21.3554 18.7986L22.4151 15.0934L23.6052 18.6404Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0721 22.8248L17.0871 19.7546L20.5172 21.0197L16.9358 22.1018L19.3443 19.0933L19.0721 22.8248Z",
    fill: "#FFFF00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136708"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.441406,
    y: 3.2832,
    width: 55,
    height: 36.5837,
    rx: 6.87414,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyCnh);
export default __webpack_public_path__ + "static/media/Currency=CNH.401e7c1c4a42bc3dae15501dfdd0beed.svg";
export { ForwardRef as ReactComponent };